import { type PayloadAction, createAction, createReducer } from '@reduxjs/toolkit';
import { mapBillingDataSubscription } from 'reactApp/modules/billingData/billingData.helpers';
import type { GetBillingDataRequesSuccessAction } from 'reactApp/modules/billingData/billingData.types';

import type { PastSubscriptionsState } from './pastSubscriptions.types';

const initialState: PastSubscriptionsState = {
    subscription: {},
    isLoading: false,
    isLoaded: false,
    hasError: false,
};

export const pastSubscriptionsRequest = createAction('pastSubscriptions/setRequest');
export const pastSubscriptionsSuccess = createAction<GetBillingDataRequesSuccessAction>('pastSubscriptions/setSuccess');
export const pastSubscriptionsFailure = createAction('pastSubscriptions/setFailure');

const handlePastSubscriptionsAction = (
    state: any,
    { payload: { billingData } }: PayloadAction<GetBillingDataRequesSuccessAction>
): PastSubscriptionsState => ({
    ...state,
    subscription: mapBillingDataSubscription(billingData),
    isLoading: false,
    isLoaded: true,
    hasError: false,
});

export const pastSubscriptionsReducer = createReducer(initialState, {
    [pastSubscriptionsSuccess.type]: handlePastSubscriptionsAction,
    [pastSubscriptionsRequest.type]: (state) => {
        state.isLoading = true;
    },
    [pastSubscriptionsFailure.type]: (state) => {
        state.isLoaded = true;
        state.isLoading = false;
        state.hasError = true;
    },
});
